import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Box } from '@radix-ui/themes';

import { useRootStore } from 'core/hooks/use-root-store';
import { GlobalLoader } from 'shared/components/global-loader';

type AuthRoutesGuardProps = {
   candidateRedirectTo?: string;
   recruiterRedirectTo?: string;
};

const AuthRoutesGuardView = ({
   candidateRedirectTo = '/candidate/my-cv-list',
   recruiterRedirectTo = '/user/myprofile',
}: AuthRoutesGuardProps) => {
   const rootStore = useRootStore();
   const { pathname } = useLocation();
   const passthroughPaths = ['/tg/job'];

   if (rootStore.userStore.isInit) {
      return (
         <Box width="100%" height="100vh">
            <GlobalLoader loaderStore={rootStore.globalLoader} />
         </Box>
      );
   }

   if (!rootStore.userStore.user) {
      return <Outlet />;
   }

   if (passthroughPaths.includes(pathname)) {
      return <Outlet />;
   }

   if (rootStore.userStore.user.user_type === 'candidate') {
      return <Navigate to={candidateRedirectTo} replace />;
   }

   if (rootStore.userStore.user.user_type === 'recruiter') {
      return <Navigate to={recruiterRedirectTo} replace />;
   }

   return <Navigate to="/" replace />;
};

export const AuthRoutesGuard = observer(AuthRoutesGuardView);
